/**
 * @typedef {(ATTACK | DIE | IDLE | START)} TypeAction An action.
 */

/**
 * The 'ATTACK' action.
 * @type {'ACTION_ATTACK'}
 * @constant
 */
const ATTACK = 'ACTION_ATTACK';

/**
 * The 'DIE' action.
 * @type {'ACTION_DIE'}
 * @constant
 */
const DIE = 'ACTION_DIE';

/**
 * The 'IDLE' action.
 * @type {'ACTION_IDLE'}
 * @constant
 */
const IDLE = 'ACTION_IDLE';

/**
 * The 'START' action.
 * @type {'ACTION_START'}
 * @constant
 */
const START = 'ACTION_START';

export {

    ATTACK,
    DIE,
    IDLE,
    START
};
